import {gql} from '@apollo/client'

export const GET_ALL_GROUPS = gql`
  query allGroupAssignments(
    $offset: Int
    $before: String
    $after: String
    $first: Int
    $last: Int
    $id: String
    $name: String
    $nameIcontains: String
    $nameIstartswith: String
    $userName: String
    $organization: String
  ) {
    allGroupAssignments(
      offset: $offset
      before: $before
      after: $after
      first: $first
      last: $last
      id: $id
      name: $name
      nameIcontains: $nameIcontains
      nameIstartswith: $nameIstartswith
      userName: $userName
      organization: $organization
    ) {
      totalCount
      pageInfo {
        hasNextPage
      }
      edges {
        node {
          id
          created
          name
          supervisors {
            edges {
              node {
                id
                firstName
                lastName
                email
                rol
              }
            }
          }
          organization {
            id
            name
          }
          user {
            edges {
              node {
                id
                firstName
                lastName
                email
                rol
              }
            }
          }
        }
      }
    }
}
`

export const GET_GROUPS_SIMPLE = gql`
  query allAssignmentGroupsList {
    allAssignmentGroupsList {
      id
      name
    }
  }
`

export const GET_MY_ASSIGNMENT_GROUPS = gql`
  query myAssignmentGroups {
    myAssignmentGroups {
      id
      name
    }
  }
`
